export default "<div *ngIf=\"message\" class=\"center\">\n    {{message}}\n</div>"